import moment from "moment";
import PropTypes from "prop-types";
import React, { useState } from "react";

import { withStyles, withTheme } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Typography from "../../../../components/Helpers/Typography";
// eslint-disable-next-line import/no-cycle
import { DiagnosticTable } from "./DiagnosticModal";

const styles = (theme) => ({
  dialog: {
    color: theme.palette.text.primary,
  },
  dialogIcon: {
    float: "right",
    top: "-12px",
    right: "24px",
    color: theme.palette.text.primary,
  },
  dialogBar: {
    padding: "20px 0px 8px 24px",
  },
  formattedEvent: {
    paddingBottom: 14,
    marginBottom: 0,
    fontFamily: "Roboto",
    backgroundColor: theme.palette.primary.main,
  },
  container: {
    margin: "0",
    width: "100%",
    paddingRight: 0,
    paddingTop: 12,
    paddingBottom: 12,
  },
  Accordion: {
    boxShadow: "none",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.primary.divider,
    backgroundColor: theme.palette.primary.dark,
    paddingLeft: 0,
  },
});

export const EventItem = (props) => {
  const getDiagnosticPresentation = (diagnostic) => {
    const cells = {
      timestamp: <span>{moment(diagnostic.timestamp).format("MMMM DD, YYYY HH:mm:ss")}</span>,
      location: <span />,
    };

    const formatLatLong = (value, posChar, negChar) => {
      if (value < 0) {
        return `${Math.abs(value)}\u00b0${negChar}`;
      }
      if (value > 0) {
        return `${value}\u00b0${posChar}`;
      }

      return `${value}\u00b0`;
    };

    const parseLocation = (location) => {
      if (location && location.geometry) {
        return location.geometry.coordinates;
      }
      try {
        return [location.coordinates[0], location.coordinates[1]];
      } catch (err) {
        return null;
      }
    };

    const location = parseLocation(diagnostic.location);

    if (location) {
      cells.location = (
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <Typography style={{ fontSize: 12 }} color="lightgrey">
              Location:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography className="event-latlng">
              {formatLatLong(location[1], "N", "S")}, {formatLatLong(location[0], "E", "W")}
            </Typography>
          </Grid>
        </Grid>
      );
    }

    if (diagnostic["vehicle state"]) {
      if (diagnostic["vehicle state"] === "Reserved") {
        cells.title = "SYSTEM CHECK: TRIP";
      } else {
        cells.title = "SYSTEM CHECK";
      }
      cells.type = (
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <Typography style={{ fontSize: 12 }} color="lightgrey">
              Status:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography style={{ fontSize: 12 }} color="white">
              {diagnostic["vehicle state"]}
            </Typography>
          </Grid>
        </Grid>
      );
    } else {
      cells.title = (
        <span style={{ textTransform: "uppercase" }}>
          {diagnostic.type}
          {diagnostic.description && <span>: {diagnostic.description} </span>}
        </span>
      );
    }

    const description = diagnostic.description;

    if (description) {
      cells.description = (
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <Typography style={{ fontSize: 12 }} color="lightgrey">
              Description:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography style={{ fontSize: 12 }} color="white">
              {description}
            </Typography>
          </Grid>
        </Grid>
      );
    }

    return cells;
  };

  const { event, index, classes } = props;

  const diagnosticCells = getDiagnosticPresentation(event);

  const [open, setOpen] = useState(false);
  const toggleModalState = (e, expanded) => {
    setOpen(expanded);
  };

  return (
    <Accordion className={classes.Accordion} onChange={toggleModalState}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid container spacing={1} className={classes.container} style={{ paddingRight: 0 }}>
          <Grid item xs={false} md={1} />
          <Grid item container xs={5}>
            <Grid
              item
              xs={2}
              md={1}
              style={{
                paddingRight: 0,
                paddingTop: 4,
                paddingBottom: 4,
              }}
            >
              <Typography style={{ fontSize: 14 }} color="lightgrey">
                {index + 1}
              </Typography>
            </Grid>
            <Grid item xs={10} md={11} style={{ paddingTop: 4, paddingBottom: 4 }}>
              <Typography style={{ fontSize: 14 }}>{diagnosticCells.title}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ fontSize: 12 }} color="lightgrey">
              {diagnosticCells.timestamp}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        {open && (
          <Grid container>
            <Grid item xs={1} />
            <Grid item md={5} xs={11}>
              <Grid container>
                <Grid item xs={1} />
                <Grid item xs={11}>
                  {diagnosticCells.type}
                  {diagnosticCells.description}
                  {diagnosticCells.location}
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <DiagnosticTable diagnostics={event} />
            </Grid>
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

EventItem.propTypes = {
  classes: PropTypes.object.isRequired,
  // should be event: PropTypes.instanceOf(TimelineEvent).isRequired
  // but the object is mutated
  event: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default withStyles(styles)(withTheme(EventItem));
